import * as IconsSVG from "../../assets/iconsSVG";
import { ContactContainer, EmailContact, WhatsAppContact } from "./styles";

const SellerSp = (
  <ContactContainer>
    {/* Email */}
    <EmailContact>
      <IconsSVG.MailBlockIcon /> {/* Ícone de envelope */}
      <a href="mailto:pessoaseorganizacao@sellerassociados.com.br">
        pessoaseorganizacao@sellerassociados.com.br
      </a>
    </EmailContact>

    {/* WhatsApp Contacts */}
    <WhatsAppContact>
      <IconsSVG.WhatsappIcon /> {/* Ícone de envelope */}
      <a
        href="https://wa.me/5511942113944"
        target="_blank"
        rel="noopener noreferrer"
      >
        (11) 94211-3944
      </a>
    </WhatsAppContact>

    <WhatsAppContact>
      <IconsSVG.WhatsappIcon /> {/* Ícone de envelope */}
      <a
        href="https://wa.me/5511974484616"
        target="_blank"
        rel="noopener noreferrer"
      >
        (11) 97448-4616
      </a>
    </WhatsAppContact>

    <WhatsAppContact>
      <IconsSVG.WhatsappIcon /> {/* Ícone de envelope */}
      <a
        href="https://wa.me/5511989954273"
        target="_blank"
        rel="noopener noreferrer"
      >
        (11) 98995-4273
      </a>
    </WhatsAppContact>
  </ContactContainer>
);

const VivazSp = (
  <ContactContainer>
    {/* Email */}
    <EmailContact>
      <IconsSVG.MailBlockIcon /> {/* Ícone de envelope */}
      <a href="mailto:pessoaseorganizacao@vivazhouse.com.br">
        pessoaseorganizacao@vivazhouse.com.br
      </a>
    </EmailContact>

    {/* WhatsApp Contacts */}
    <WhatsAppContact>
      <IconsSVG.WhatsappIcon /> {/* Ícone de envelope */}
      <a
        href="https://wa.me/5511942639227"
        target="_blank"
        rel="noopener noreferrer"
      >
        (11) 94263-9227
      </a>
    </WhatsAppContact>

    <WhatsAppContact>
      <IconsSVG.WhatsappIcon /> {/* Ícone de envelope */}
      <a
        href="https://wa.me/5511933397998"
        target="_blank"
        rel="noopener noreferrer"
      >
        (11) 93339-7998
      </a>
    </WhatsAppContact>
  </ContactContainer>
);

const VivazVendas = (
  <ContactContainer>
    <EmailContact>
      <IconsSVG.MailBlockIcon /> {/* Ícone de envelope */}
      <a href="mailto:consultoriarhvivazvendas@cyrela.com.br">
        consultoriarhvivazvendas@cyrela.com.br
      </a>
    </EmailContact>
  </ContactContainer>
);

const Rj = (
  <ContactContainer>
    {/* Email */}
    <EmailContact>
      <IconsSVG.MailBlockIcon /> {/* Ícone de envelope */}
      <a href="mailto:SellerPessoas@rjzcyrela.com.br">
        SellerPessoas@rjzcyrela.com.br
      </a>
    </EmailContact>

    {/* WhatsApp Contacts */}
    <WhatsAppContact>
      <IconsSVG.WhatsappIcon /> {/* Ícone de envelope */}
      <a
        href="https://wa.me/5521973372292"
        target="_blank"
        rel="noopener noreferrer"
      >
        (21) 97337-2292
      </a>
    </WhatsAppContact>

    <WhatsAppContact>
      <IconsSVG.WhatsappIcon /> {/* Ícone de envelope */}
      <a
        href="https://wa.me/5521973426370"
        target="_blank"
        rel="noopener noreferrer"
      >
        (21) 97342-6370
      </a>
    </WhatsAppContact>
  </ContactContainer>
);

const Sul = (
  <ContactContainer>
    {/* Email */}
    <EmailContact>
      <IconsSVG.MailBlockIcon /> {/* Ícone de envelope */}
      <a href="mailto:rhvendassul@cyrela.com.br">rhvendassul@cyrela.com.br</a>
    </EmailContact>
  </ContactContainer>
);

const Contacts = {
  SellerSp,
  VivazSp,
  VivazVendas,
  Rj,
  Sul,
};

export default Contacts;
